export default {
  xl: {
    fontSize: 24,
    fontWeight: 900,
  },
  lg: {
    fontSize: 18,
    fontWeight: 500,
  },
  mlgb: {
    fontSize: 16,
    fontWeight: 500,
  },
  mlg: {
    fontSize: 16,
    fontWeight: 300,
  },
  mdb: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  md: {
    fontSize: 14,
    fontWeight: 300,
  },
  sm: {
    fontSize: 12,
    fontWeight: 500,
  },
  xs: {
    fontSize: 10,
    fontWeight: 500,
  },
};
